
import { useState, useEffect } from 'react';
import { saveToLocalStorage, getFromLocalStorage } from '@/utils/storage';
import { 
  savePromoCodeToStorage,
  getPromoCodeFromStorage,
  getAppliedCreditFromStorage,
  saveAppliedCreditToStorage
} from '@/utils/cart/cartStorageUtils';
import { CartProduct } from '@/contexts/CartContext';

export const useCartStorage = (userId: string) => {
  const [cartItems, setCartItems] = useState<CartProduct[]>(() => {
    const storedCartItems = getFromLocalStorage(`cart_${userId}`) || [];
    return Array.isArray(storedCartItems) ? storedCartItems : [];
  });
  
  const [promoCode, setPromoCode] = useState<string>(() => {
    const storedPromoCode = getPromoCodeFromStorage(userId);
    console.log('Initial promoCode from storage:', storedPromoCode);
    return storedPromoCode;
  });
  
  const [appliedCredit, setAppliedCredit] = useState<number>(() => {
    const storedCredit = getAppliedCreditFromStorage(userId);
    console.log('Initial appliedCredit from storage:', storedCredit);
    return storedCredit;
  });

  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Save cart items to storage when they change (only for guest users)
  useEffect(() => {
    if (!isLoading && userId === 'guest') {
      console.log(`Saving ${cartItems.length} cart items to localStorage for guest user`);
      saveToLocalStorage(`cart_${userId}`, cartItems);
    }
    // For authenticated users, don't save to localStorage - only use Supabase
  }, [cartItems, userId, isLoading]);

  // Save promo code to storage when it changes (only for guest users)
  useEffect(() => {
    if (!isLoading && userId === 'guest') {
      console.log('Saving promoCode to localStorage for guest user:', promoCode);
      savePromoCodeToStorage(userId, promoCode);
    }
  }, [promoCode, userId, isLoading]);
  
  // Save applied credit to storage when it changes (only for guest users)
  useEffect(() => {
    if (!isLoading && userId === 'guest') {
      console.log('Saving appliedCredit to localStorage for guest user:', appliedCredit);
      saveAppliedCreditToStorage(userId, appliedCredit);
    }
  }, [appliedCredit, userId, isLoading]);

  // Save applied credit to sessionStorage for authenticated users for payment processing
  useEffect(() => {
    if (!isLoading && userId !== 'guest') {
      console.log('Saving appliedCredit to sessionStorage for authenticated user:', appliedCredit);
      sessionStorage.setItem('appliedCredit', JSON.stringify({ amount: appliedCredit }));
    }
  }, [appliedCredit, userId, isLoading]);

  return {
    cartItems,
    setCartItems,
    promoCode,
    setPromoCode,
    appliedCredit,
    setAppliedCredit,
    isLoading,
    setIsLoading
  };
};
